import axios from "axios";
import { API_URL } from "config";
import { getToken } from "utils/getToken";

export const getAssetsImportTemplate = ({ churchId }) => {
  return axios.get(`${API_URL}/churches/${churchId}/assets-template`, {
    headers: {
      Authorization: getToken()
    },
    responseType: "blob"
  });
};
